import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import {
    getCalculatedFolderId,
    getCalendarGroupKey,
    Calendar,
    CalendarId,
    CalendarCacheStoreData,
} from 'owa-calendar-cache';
import { getUserMailboxInfo } from 'owa-client-ids';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { shouldAddCalendarToCache } from './shouldAddCalendarToCache';
import { CalendarGroup, CalendarEntry } from 'owa-graph-schema';

export function convertToCalendarCacheStoreData(
    groups: CalendarGroup[],
    userIdentity?: string
): CalendarCacheStoreData {
    let defaultCalendar: Calendar;
    let calendarEntryMapping: { [key: string]: CalendarEntry } = {};
    let folderIdMapping: { [key: string]: CalendarId } = {};
    let calendarGroupMapping: { [key: string]: CalendarGroup } = {};
    let calendarIdToChangeKeyMapping: { [key: string]: string } = {};
    let calendarKeys: string[] = userIdentity
        ? [userIdentity]
        : [getUserConfiguration().SessionSettings.LogonEmailAddress];

    const userMailboxInfo = getUserMailboxInfo(userIdentity);

    groups.forEach((group: CalendarGroup) => {
        calendarIdToChangeKeyMapping[group.calendarGroupId.itemId.Id] =
            group.calendarGroupId.itemId.ChangeKey;

        const groupKey = getCalendarGroupKey(userMailboxInfo.userIdentity, group.serverGroupId);
        calendarGroupMapping[groupKey] = group;
        group.Calendars.forEach(calendarEntry => {
            if (shouldAddCalendarToCache(calendarEntry, calendarKeys)) {
                let entryId = calendarEntry.calendarId.itemId.Id;
                let calcFolderId = getCalculatedFolderId(calendarEntry).Id;

                if (calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.DefaultCalendar) {
                    defaultCalendar = {
                        id: { id: entryId, mailboxInfo: userMailboxInfo },
                        calculatedFolderId: calcFolderId,
                        displayName: calendarEntry.CalendarName,
                        colorScheme: null,
                    };
                }

                // Do not override any existent mapping.
                // One case it protects for is when user shares its own calendar with himself.
                !calendarEntryMapping[entryId] && (calendarEntryMapping[entryId] = calendarEntry);
                !folderIdMapping[calcFolderId] &&
                    (folderIdMapping[calcFolderId] = {
                        id: calendarEntry.calendarId.itemId.Id,
                        mailboxInfo: userMailboxInfo,
                    });

                !calendarIdToChangeKeyMapping[entryId] &&
                    (calendarIdToChangeKeyMapping[entryId] =
                        calendarEntry.calendarId.itemId.ChangeKey);
            }
        });
    });

    return {
        defaultCalendar: defaultCalendar,
        calendarEntryMapping: calendarEntryMapping,
        folderIdMapping: folderIdMapping,
        calendarGroupMapping: calendarGroupMapping,
        calendarIdToChangeKeyMapping: calendarIdToChangeKeyMapping,
    };
}
